import { getDataMapper, getObjectId, mapField } from "@/shared";

export const mapRepairInventoryToServer = getDataMapper(
    {
        inventory_id: mapField("inventory", getObjectId),
        count: mapField("count", Number),
    },
    { shouldAvoidUndefined: true }
);
